declare global {

	module PgRendererDto {
		interface AnswerkeyDto {
			InteractionDefinitions: PgRendererDto.InteractionDefinition[];
			TestletId: number;
			TestletLabel: string;
			TestletTitle: string;
		}
		interface AssessmentItem extends PgRendererDto.QtiElementBase {
			Identifier: string;
			Interactions: PgRendererDto.InteractionDefinition[];
			ItemBody: PgRendererDto.ItemBody;
			TimeDependent: boolean;
			TimeLimits: PgRendererDto.TimeLimits;
			Title: string;
		}
		interface AssessmentSection extends PgRendererDto.SectionPart {
			RubricBlocks: PgRendererDto.RubricBlock[];
			SectionParts: PgRendererDto.SectionPart[];
		}
		interface AssessmentSectionRef extends PgRendererDto.SectionPart {
			Href: string;
			Identifier: string;
			IsInjectedForFieldTesting: boolean;
			MaxTime: number;
			PageHeader: string;
			TestletId: number;
			Title: string;
		}
		interface AssessmentTest extends PgRendererDto.QtiElementBase {
			Identifier: string;
			TestParts: PgRendererDto.TestPart[];
			TimeLimits: PgRendererDto.TimeLimits;
			TimingSpecification: PgRendererDto.KeyValuePair<number, number>[];
			Title: string;
		}
		interface AssociableChoice extends PgRendererDto.Choice {
		}
		interface AssociateInteraction extends PgRendererDto.SimpleAssociableChoiceContainerInteraction {
			MaxAssociations: number;
			MinAssociations: number;
			Shuffle: boolean;
			SimpleAssociableChoices: PgRendererDto.SimpleAssociableChoice[];
		}
		interface AttributeDto {
			AttributeName: string;
			DataTypeId: number;
			DataTypeName: string;
			EntityAttributeTypeId: number;
			EntityTypeId: number;
			EntityTypeName: string;
			Id: number;
			IsSystem: boolean;
			Value: string;
		}
		interface Block {
			Content: string;
		}
		interface BlockInteraction extends PgRendererDto.InteractionBase {
			Prompt: string;
		}
		interface BodyElement extends PgRendererDto.QtiElementBase {
		}
		interface Choice extends PgRendererDto.BodyElement {
			ChoiceDisplayOrder: number;
			Identifier: string;
		}
		interface ChoiceInteraction extends PgRendererDto.SimpleChoiceInteraction {
			MaxChoices: number;
			MinChoices: number;
			Orientation: OrientationEnum;
			Shuffle: boolean;
		}
		interface Coords {
			Data: number[];
		}
		interface CorrectResponse extends PgRendererDto.QtiElementBase {
			Values: PgRendererDto.Value[];
		}
		interface ExtendedTextInteraction extends PgRendererDto.StringInteraction {
			ExpectedLines: number;
			FillRestPanelSpace: boolean;
			FormattingBar: boolean;
			MaxStrings: number;
			MinStrings: number;
			Prompt: string;
			SpellCheckActive: boolean;
		}
		interface GraphicInteraction extends PgRendererDto.BlockInteraction {
			ResourceObject: PgRendererDto.ResourceObject;
		}
		interface Guid {
		}
		interface Hotspot extends PgRendererDto.QtiElementBase {
			Coords: PgRendererDto.Coords;
			HotspotLabel: string;
			Shape: ShapeEnum;
		}
		interface HotspotChoice extends PgRendererDto.Choice {
			Hotspot: PgRendererDto.Hotspot;
		}
		interface HotspotInteraction extends PgRendererDto.GraphicInteraction {
			HotspotChoices: PgRendererDto.HotspotChoice[];
			MaxChoices: number;
			MinChoices: number;
		}
		interface HtmlElementBase extends PgRendererDto.XmlElementBase {
		}
		interface InlineChoice extends PgRendererDto.Choice {
			Html: string;
		}
		interface InlineChoiceInteraction extends PgRendererDto.InlineInteraction {
			InlineChoices: PgRendererDto.InlineChoice[];
			Required: boolean;
			Shuffle: boolean;
		}
		interface InlineInteraction extends PgRendererDto.InteractionBase {
		}
		interface InputPatternDto {
			BaseType: number;
			Name: string;
		}
		interface InteractionBase extends PgRendererDto.BodyElement {
			ResponseDeclaration: PgRendererDto.ResponseDeclaration;
			ResponseIdentifier: string;
			ResponseRatingType: RatingTypeEnum;
		}
		interface InteractionDefinition {
			AssociateInteraction: PgRendererDto.AssociateInteraction;
			ChoiceInteraction: PgRendererDto.ChoiceInteraction;
			ComponentTypeId: ComponentTypeEnum;
			ComponentTypeName: string;
			CrossVersionUid: number;
			ExtendedTextInteraction: PgRendererDto.ExtendedTextInteraction;
			HotspotInteraction: PgRendererDto.HotspotInteraction;
			InlineChoiceInteraction: PgRendererDto.InlineChoiceInteraction;
			InteractionId: number;
			InteractionRefNum: number;
			InteractionTypeId: InteractionTypeEnum;
			InteractionTypeName: string;
			IsAnchor: boolean;
			IsModified: boolean;
			ItemIndex: number;
			MatchInteraction: PgRendererDto.MatchInteraction;
			OrderInteraction: PgRendererDto.OrderInteraction;
			PaperBasedInteraction: PgRendererDto.PaperBasedInteraction;
			ScoreCategoryId: ScoreCategoryEnum;
			ScoreCategoryName: string;
			SpeakingInteraction: PgRendererDto.SpeakingInteraction;
			TargetDifficultyLevelId: DifficultyLevelEnum;
			TargetDifficultyLevelName: string;
			TextEntryInteraction: PgRendererDto.TextEntryInteraction;
			Version: number;
		}
		interface InteractionResponse {
			InteractionId: number;
			Items: PgRendererDto.InteractionResponseItem[];
		}
		interface InteractionResponseItem {
			ChoiceDisplayOrder: number;
			Key: string;
			Text: string;
			Value: string;
		}
		interface InteractionTypeDto {
			Code: string;
			DefaultRatingTypeId: number;
			Id: number;
			Name: string;
			ResponseTypeId: number;
		}
		interface IppAssessmentTestDto {
			AssociatedIppAssessmentTestIds: number[];
			CreatedDate: Date;
			Id: number;
			IppAssessmentTest: PgRendererDto.AssessmentTest;
			isActive: boolean;
			Name: string;
			ProductId: number;
			ProductName: string;
		}
		interface IppAssociateProductDto {
			IppAssessmentTestId: number;
			ProductId: number;
		}
		interface IppProductDto {
			Id: number;
			Name: string;
			NeedsPurchase: boolean;
		}
		interface ItemBody extends PgRendererDto.QtiElementBase {
			ItemBodyPanels: PgRendererDto.ItemBodyPanel[];
		}
		interface ItemBodyPanel extends PgRendererDto.HtmlElementBase {
			CssClass: string;
			CssStyle: string;
			Html: string;
			KeepContentSame: boolean;
			Label: string;
		}
		interface KeyValuePair<TKey, TValue> {
			Key: TKey;
			Value: TValue;
		}
		interface MapEntry extends PgRendererDto.QtiElementBase {
			CaseSensitive: boolean;
			MapKey: string;
			MappedValue: number;
		}
		interface Mapping extends PgRendererDto.QtiElementBase {
			DefaultValue: number;
			LowerBound: number;
			MapEntries: PgRendererDto.MapEntry[];
			UpperBound: number;
		}
		interface MatchInteraction extends PgRendererDto.SimpleAssociableChoiceContainerInteraction {
			MaxAssociations: number;
			MinAssociations: number;
			Shuffle: boolean;
			SimpleMatchSets: PgRendererDto.SimpleMatchSet[];
		}
		interface OrderInteraction extends PgRendererDto.SimpleChoiceInteraction {
			MaxChoices: number;
			MinChoices: number;
			Orientation: OrientationEnum;
			Shuffle: boolean;
		}
		interface PaperBasedInteraction extends PgRendererDto.BlockInteraction {
			AnswerKey: string;
			MaxScore: number;
			MinScore: number;
			Question: string;
		}
		interface ProprietaryElementBase extends PgRendererDto.XmlElementBase {
		}
		interface QtiElementBase extends PgRendererDto.XmlElementBase {
		}
		interface RelatedTestletListDto {
			Enemies: PgRendererDto.TestletDto[];
			Friends: PgRendererDto.TestletDto[];
		}
		interface ResourceDto {
			AuthorInternalUserName: string;
			ContentType: string;
			CreatedDate: Date;
			Id: number;
			IsHighlightable: boolean;
			IsLocked: boolean;
			IsSecured: boolean;
			Name: string;
			OriginalFileName: string;
			OriginalResourceId: number;
			ResourceTypeId: ResourceTypeEnum;
			ResourceTypeName: string;
			TotalTestletsInUse: number;
			Transcript: string;
		}
		interface ResourceObject extends PgRendererDto.ProprietaryElementBase {
			Data: string;
			Height: number;
			MimeType: string;
			ResourceId: number;
			Width: number;
		}
		interface ResourceTypeDto {
			Id: ResourceTypeEnum;
			Name: string;
		}
		interface ResponseDeclaration extends PgRendererDto.VariableDeclaration {
			AllowPartialScoring: boolean;
			CorrectResponse: PgRendererDto.CorrectResponse;
			Identifier: string;
			Mapping: PgRendererDto.Mapping;
		}
		interface ResponseScore {
			InteractionId: number;
			Score: number;
		}
		interface ResponseScoresDto {
			ResponseScores: PgRendererDto.ResponseScore[];
		}
		interface RubricBlock extends PgRendererDto.SimpleBlock {
			StyleSheets: PgRendererDto.StyleSheet[];
			Use: string;
			View: ViewEnum;
		}
		interface SectionDto {
			Children: PgRendererDto.SectionDto[];
			Id: number;
			IsActive: boolean;
			IsShared: boolean;
			Name: string;
			ParentId: number;
			SectionStatusId: number;
			SectionStatusName: string;
			SectionType: string;
			SectionTypeId: number;
			SharedCount: number;
			TestletDisplays: PgRendererDto.TestletDisplayDto[];
		}
		interface SectionPart extends PgRendererDto.QtiElementBase {
			TimeLimits: PgRendererDto.TimeLimits;
		}
		interface SectionTypeDto {
			Id: number;
			Name: string;
			TestletTypeDtos: PgRendererDto.TestletTypeDto[];
		}
		interface SimpleAssociableChoice extends PgRendererDto.AssociableChoice {
			Html: string;
			MatchMax: number;
			MatchMin: number;
		}
		interface SimpleAssociableChoiceContainerInteraction extends PgRendererDto.BlockInteraction {
		}
		interface SimpleBlock {
			Blocks: PgRendererDto.Block[];
			Id: number;
			Label: string;
		}
		interface SimpleChoice extends PgRendererDto.Choice {
			Html: string;
		}
		interface SimpleChoiceInteraction extends PgRendererDto.BlockInteraction {
			SimpleChoices: PgRendererDto.SimpleChoice[];
		}
		interface SimpleMatchSet extends PgRendererDto.QtiElementBase {
			SimpleAssociableChoices: PgRendererDto.SimpleAssociableChoice[];
		}
		interface SpeakingInteraction extends PgRendererDto.BlockInteraction {
			ExtendPrepTime: boolean;
			ExtendSpeakingTime: boolean;
			PreparationTime: number;
			RecordingTime: number;
		}
		interface StringInteraction extends PgRendererDto.InteractionBase {
			Base: number;
			ExpectedLength: number;
			PatternMask: string;
			PlaceHolderText: string;
		}
		interface StyleSheet {
			Href: string;
			Media: string;
			Title: string;
			Type: string;
		}
		interface TestInitializationInfo {
			CurrentTestletInteractionResponses: PgRendererDto.InteractionResponse[];
			TestTakerProgress: PgRendererDto.TestTakerProgress;
		}
		interface TestletDefinition extends PgRendererDto.AssessmentSection {
			AssessmentItems: PgRendererDto.AssessmentItem[];
			Identifier: string;
			Title: string;
			Visible: boolean;
		}
		interface TestletDetailDto extends PgRendererDto.TestletDto {
			AnchoredReferencedInteractions: number;
			AnchoredUnreferencedInteractions: number;
			RelatedTestletList: PgRendererDto.RelatedTestletListDto;
			TestletDefinition: PgRendererDto.TestletDefinition;
			TestTakersInEquating: number;
			TotalReferencedInteractions: number;
			TotalUnreferencedInteractions: number;
		}
		interface TestletDisplayDto {
			Id: number;
			Label: string;
			PreviewRequired: boolean;
			Title: string;
		}
		interface TestletDto {
			BankId: number;
			ComponentTypes: number[];
			CurrentMajorVersion: number;
			CurrentMinorVersion: number;
			CurrentSampleSize: number;
			CurrentSampleSizeNotProcessed: number;
			CurrentVersionComment: string;
			DateCreated: Date;
			DateDelivered: Date;
			DateModified: Date;
			Description: string;
			DesiredFieldTestingSampleSize: number;
			DifficultyLevelId: number;
			DifficultyLevelName: string;
			FieldTestedSince: Date;
			FieldTestingPriorityId: FieldTestingPriorityEnum;
			FieldTestingPriorityName: string;
			Id: number;
			IppAssessmentTestNames: string[];
			IsDeleted: boolean;
			IsInstructional: boolean;
			IsPaperBased: boolean;
			IsPreviewed: boolean;
			Label: string;
			ListOfAttributeNames: string;
			ShouldPromptPreviewTestTypeSelection: boolean;
			SourceReferences: string;
			SubjectId: number;
			TestletAttributes: PgRendererDto.AttributeDto[];
			TestletStateId: TestletStateEnum;
			TestletStateName: string;
			TestletType: PgRendererDto.TestletTypeDto;
			TestletTypeName: string;
			TestTypes: number[];
			Title: string;
			TopicId: number;
		}
		interface TestletSnapshotDto {
			AttributeUpdateFlag: boolean;
			HasMinorOrMajorChange: boolean;
			RelationUpdateFlag: boolean;
			TestletDetail: PgRendererDto.TestletDetailDto;
			TestletUpdateType: TestletUpdateTypeEnum;
		}
		interface TestletTypeDto {
			Code: string;
			DefaultComponentTypeId: number;
			Id: number;
			Name: string;
		}
		interface TestPart extends PgRendererDto.QtiElementBase {
			AssessmentSectionRefs: PgRendererDto.AssessmentSectionRef[];
			NavigationMode: string;
			SubmissionMode: string;
			TimeLimits: PgRendererDto.TimeLimits;
		}
		interface TestTakerActivity {
			ActivityTypeId: number;
			DateCreatedUtc: Date;
			InteractionId: number;
			ItemIndex: number;
			NumericValue: number;
			TestletId: number;
			TestletIndex: number;
			TestPartIndex: number;
			TextValue: string;
		}
		interface TestTakerPing {
			ClientApplicationSessionId: PgRendererDto.Guid;
			StationNumber: number;
			TestSessionId: number;
			TestTakerId: number;
		}
		interface TestTakerProgress {
			CurrentTestletIndex: number;
			CurrentTestletUsedSeconds: number;
			CurrentTestPartIndex: number;
		}
		interface TestTakerResponse {
			ClientApplicationSessionId: PgRendererDto.Guid;
			CurrentTestletUsedSeconds: number;
			InteractionResponses: PgRendererDto.InteractionResponse[];
			TestSessionId: number;
			TestTakerActivities: PgRendererDto.TestTakerActivity[];
			TestTakerId: number;
		}
		interface TestTakerStationAssignment {
			AssessmentTestId: number;
			BrandName: string;
			ClientApplicationSessionId: PgRendererDto.Guid;
			CtcCode: string;
			FirstName: string;
			FirstNameLocalLanguage: string;
			IsNonScored: boolean;
			LastName: string;
			LastNameLocalLanguage: string;
			PIN: string;
			StartCode: string;
			StationNumber: number;
			TestSessionId: number;
			TestSessionSiteCode: string;
			TestTakerId: number;
			TestTypeId: TestTypeEnum;
			TestTypeName: string;
		}
		interface TextEntryInteraction extends PgRendererDto.StringInteraction {
		}
		interface TimeLimits extends PgRendererDto.QtiElementBase {
			MaxTime: number;
			MinTime: number;
		}
		interface Value extends PgRendererDto.QtiElementBase {
			DataValue: string;
		}
		interface VariableDeclaration extends PgRendererDto.QtiElementBase {
			BaseType: BaseTypeEnum;
			Cardinality: CardinalityEnum;
			Identifier: string;
		}
		interface XmlElementBase {
		}
	}
	
	}
		export const enum BankEnum {
			None = 0,
			Live = 1,
			TrainingMaterial = 2,
			InstructionalProducts = 3
		}
		export const enum BaseTypeEnum {
			Identifier = 1,
			Boolean = 2,
			Integer = 3,
			Float = 4,
			String = 5,
			Point = 6,
			Pair = 7,
			DirectedPair = 8,
			Duration = 9,
			File = 10,
			Uri = 11,
			IntOrIdentifier = 12
		}
		export const enum BrandEnum {
			CELPIP = 1,
			CAEL = 2,
			LPI = 3
		}
		export const enum CardinalityEnum {
			Single = 1,
			Multiple = 2,
			Ordered = 3,
			Record = 4
		}
		export const enum ComponentTypeEnum {
			Listening = 1,
			Reading = 2,
			Writing = 3,
			Speaking = 4,
			Nonspecific = 5,
			Overall = 6,
			DSCScore = 7,
			SSSCore = 8,
			EUScore = 9,
			Essay = 10,
			Level = 11
		}
		export const enum DifficultyLevelEnum {
			Easy = 20,
			Medium = 50,
			Difficult = 100
		}
		export const enum FieldTestingPriorityEnum {
			None = 10,
			Normal = 20,
			High = 30
		}
		export const enum InteractionTypeEnum {
			Choice = 1,
			InlineChoice = 2,
			TextEntry = 3,
			ExtendedText = 4,
			Speaking = 5,
			Hotspot = 6,
			Order = 7,
			Associate = 8,
			Match = 9,
			PaperBased = 10
		}
		export const enum OrientationEnum {
			Vertical = 1,
			Horizontal = 2
		}
		export const enum RatingTypeEnum {
			HumanRated = 1,
			MachineScored = 2
		}
		export const enum ResourceTypeEnum {
			Picture = 1,
			Audio = 2,
			Video = 3,
			HTML = 4,
			PDF = 5
		}
		export const enum ScoreCategoryEnum {
			Global = 1,
			Inference = 2,
			Local = 3,
			NotSpecified = 4
		}
		export const enum ShapeEnum {
			Default = 1,
			Rect = 2,
			Circle = 3,
			Poly = 4,
			Ellipse = 5
		}
		export const enum TestletStateEnum {
			Created = 1,
			InFieldTesting = 2,
			RevisionNeeded = 3,
			Revised = 4,
			ReadyForDecisionMaking = 5,
			Operational = 6,
			InHibernation = 7,
			Rejected = 8,
			PermanentlyRetired = 9
		}
		export const enum TestletUpdateTypeEnum {
			MetaDataUpdate = 1,
			MinorVersionUpdate = 2,
			MajorVersionUpdate = 3
		}
		export const enum TestTakerActivityTypeEnum {
			EnterTestlet = 100,
			LeaveTestlet = 101,
			TestletTimeout = 102,
			SetResponse = 103,
			StartSpeaking = 104,
			SetAssessmentItemIndex = 105,
			PageNavigationArrowClick = 106,
			TabClick = 107,
			IgnoreMinWordCountWarningYes = 108,
			IgnoreMinWordCountWarningNo = 109,
			IgnoreUnansweredInteractionWarningYes = 110,
			IgnoreUnansweredInteractionWarningNo = 111,
			TestStart = 200,
			TestResume = 201,
			TestEnd = 203,
			ScreenLockStart = 204,
			ScreenLockEnd = 205,
			NewApplicationSession = 206,
			StationAssigned = 207,
			PinWrongInput = 208,
			PinCorrectInput = 209,
			StartCodeWrongInput = 210,
			StartCodeCorrectInput = 211,
			ApplicationShutdownUnknown = 430,
			ApplicationShutdownProgramFailure = 431,
			ApplicationShutdownHardwareIssue = 432,
			ApplicationShutdownTestTakerBreak = 433,
			ApplicationShutdownEndOfTest = 435,
			ApplicationShutdownOther = 436
		}
		export const enum TestTypeEnum {
			CELPIP_G = 5,
			CELPIP_LS = 7,
			DEMO_G_2014 = 8,
			PILOT_G_2014 = 10,
			PRETEST_G = 11,
			PRETEST_LS = 12,
			RESEARCH_G = 13,
			CELPIP_SAFT = 14,
			CAEL = 20,
			CAEL_PLACEMENT = 21,
			CAEL2 = 22,
			SAFT = 23,
			CAEL_CE_DEMO = 24,
			LPI = 25,
			CAEL_SAFT = 26
		}
		export const enum ViewEnum {
			Author = 1,
			Candidate = 2,
			Proctor = 3,
			Scorer = 4,
			TestConstructor = 5,
			Tutor = 6
		}	


// WEBPACK FOOTER //
// C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/dtos/enums.ts